"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uuid = require("uuid");
var _plantNursery = require("@/services/plant-nursery.service");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  name: 'EditSectionsModal',
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    section: {
      type: Object,
      default: null
    }
  },
  emits: ['submit', 'onClose'],
  data: function data() {
    return {
      form: this.createDefaultForm(),
      rows: this.createDefaultRows(),
      isRowSaving: false,
      savingRowKey: null,
      deletingRowKey: null
    };
  },
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.resetForm();
      }
    },
    section: {
      handler: function handler() {
        this.resetForm();
      },
      deep: true
    }
  },
  methods: {
    createDefaultForm: function createDefaultForm() {
      var _this$section$name, _this$section, _this$section2;
      return {
        name: (_this$section$name = (_this$section = this.section) === null || _this$section === void 0 ? void 0 : _this$section.name) !== null && _this$section$name !== void 0 ? _this$section$name : '',
        hardeningArea: Boolean((_this$section2 = this.section) === null || _this$section2 === void 0 ? void 0 : _this$section2.hardeningArea)
      };
    },
    createDefaultRows: function createDefaultRows() {
      var _this$section3;
      if (!Array.isArray((_this$section3 = this.section) === null || _this$section3 === void 0 ? void 0 : _this$section3.rows)) return [];
      return this.section.rows.map(function (row) {
        var _row$id, _row$name;
        return {
          id: (_row$id = row === null || row === void 0 ? void 0 : row.id) !== null && _row$id !== void 0 ? _row$id : null,
          name: (_row$name = row === null || row === void 0 ? void 0 : row.name) !== null && _row$name !== void 0 ? _row$name : '',
          localKey: (0, _uuid.v4)()
        };
      });
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
      this.rows = this.createDefaultRows();
    },
    handleClose: function handleClose() {
      this.resetForm();
      this.$emit('onClose');
    },
    submitForm: function submitForm() {
      var _this$section4;
      if (!this.form.name.trim()) {
        this.$buefy.toast.open({
          message: 'Informe o nome do setor.',
          type: 'is-danger'
        });
        return;
      }
      var payload = {
        sectionId: (_this$section4 = this.section) === null || _this$section4 === void 0 ? void 0 : _this$section4.id,
        name: this.form.name.trim(),
        hardeningArea: this.form.hardeningArea
      };
      this.$emit('submit', payload);
    },
    addRow: function addRow() {
      this.rows.push({
        id: null,
        name: '',
        localKey: (0, _uuid.v4)()
      });
    },
    saveRow: function () {
      var _saveRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _this$section5;
        var name, _data$id, _yield$plantNurserySe, data, _error$response, _error$response$data, message, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if ((_this$section5 = this.section) !== null && _this$section5 !== void 0 && _this$section5.id) {
                _context.n = 1;
                break;
              }
              this.$buefy.toast.open({
                message: 'Setor inválido.',
                type: 'is-danger'
              });
              return _context.a(2);
            case 1:
              name = (row.name || '').trim();
              if (name) {
                _context.n = 2;
                break;
              }
              this.$buefy.toast.open({
                message: 'Informe o nome da rua.',
                type: 'is-danger'
              });
              return _context.a(2);
            case 2:
              this.isRowSaving = true;
              this.savingRowKey = row.localKey;
              _context.p = 3;
              if (!row.id) {
                _context.n = 5;
                break;
              }
              _context.n = 4;
              return _plantNursery.plantNurseryService.updateSectionRow(row.id, {
                name: name
              });
            case 4:
              _context.n = 7;
              break;
            case 5:
              _context.n = 6;
              return _plantNursery.plantNurseryService.createSectionRow(this.section.id, {
                name: name
              });
            case 6:
              _yield$plantNurserySe = _context.v;
              data = _yield$plantNurserySe.data;
              row.id = (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : row.id;
            case 7:
              this.$emit('rowsChanged');
              this.$buefy.toast.open({
                message: 'Rua salva com sucesso.',
                type: 'is-success'
              });
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t = _context.v;
              message = (_t === null || _t === void 0 ? void 0 : (_error$response = _t.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t === null || _t === void 0 ? void 0 : _t.message) || 'Falha ao salvar rua.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 9:
              _context.p = 9;
              this.isRowSaving = false;
              this.savingRowKey = null;
              return _context.f(9);
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[3, 8, 9, 10]]);
      }));
      function saveRow(_x) {
        return _saveRow.apply(this, arguments);
      }
      return saveRow;
    }(),
    deleteRow: function () {
      var _deleteRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _error$response2, _error$response2$data, message, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (row !== null && row !== void 0 && row.id) {
                _context2.n = 1;
                break;
              }
              this.rows = this.rows.filter(function (item) {
                return item.localKey !== row.localKey;
              });
              return _context2.a(2);
            case 1:
              this.isRowSaving = true;
              this.deletingRowKey = row.localKey;
              _context2.p = 2;
              _context2.n = 3;
              return _plantNursery.plantNurseryService.deleteSectionRow(row.id);
            case 3:
              this.rows = this.rows.filter(function (item) {
                return item.localKey !== row.localKey;
              });
              this.$emit('rowsChanged');
              this.$buefy.toast.open({
                message: 'Rua removida com sucesso.',
                type: 'is-success'
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              message = (_t2 === null || _t2 === void 0 ? void 0 : (_error$response2 = _t2.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Falha ao remover rua.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 5:
              _context2.p = 5;
              this.isRowSaving = false;
              this.deletingRowKey = null;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function deleteRow(_x2) {
        return _deleteRow.apply(this, arguments);
      }
      return deleteRow;
    }()
  }
};